function getHandleNameByTitle(title) {
  const lowercaseTitle = title.toLowerCase();
  const handle = lowercaseTitle.replace(/\s+/g, '-');
  const cleanHandle = handle.replace(/[^a-z0-9-]/g, '');

  return cleanHandle;
}

function getSwatchHtmlComponent(item, productHandle) {
  const swatchColorCode = `${item.variant_title
    .split('/')[1]
    ?.trim()
    .toLowerCase()
    .replace(' ', '-')}--${
    productHandle ? productHandle : getHandleNameByTitle(item.product_title)
  }`;
  return `
                <span class="swatch-image swatch--${swatchColorCode}"></span>
              `;
}

function getPropertiesFromItem(item) {
  const properties = item.properties.reduce((accumulator, currentValue) => {
    accumulator[currentValue.name] = currentValue.value;
    return accumulator;
  }, {});

  return properties;
}

function getRechargeDateFromDateString(date) {
  if (!date) return new Date();

  const parts = date.split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  return new Date(year, month, day);
}

function getFormattedDateString(dateString) {
  const date = getRechargeDateFromDateString(dateString);
  return date.toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

function getDateHtmlComponent(item) {
  const tagText =
    item?.charge_interval_frequency && item?.charge_interval_frequency
      ? `Every ${item?.charge_interval_frequency} Month${
          item?.charge_interval_frequency > 1 ? 's' : ''
        }`
      : 'One-Time';

  return `
     <p class="next-order-date title-font-7">
        ${getFormattedDateString(item?.next_charge_scheduled_at)}
                
        <span class="frequency-badge body-font-3 ">
            ${tagText}
        </span>
     </p>
    `;
}

function getThousandDividedNumberFromString(string) {
  const numericString = string.replace(/[^\d]/g, '');
  const formattedNumber = parseInt(numericString).toLocaleString('en-US');
  return `(${formattedNumber})`;
}

export {
  getHandleNameByTitle,
  getSwatchHtmlComponent,
  getPropertiesFromItem,
  getFormattedDateString,
  getDateHtmlComponent,
  getThousandDividedNumberFromString
};
